import styled from 'styled-components';

const AddressWrapper = styled.div`
  .isoInputWrapper {
      margin-bottom: 15px;

      &:last-of-type {
        margin-bottom: 0;
      }

      input {
        &::-webkit-input-placeholder {
          color: #bababa;
        }

        &:-moz-placeholder {
          color: #bababa;
        }

        &::-moz-placeholder {
          color: #bababa;
        }
        &:-ms-input-placeholder {
          color: #bababa;
        }
      }
    }
  }
`;

export default AddressWrapper;


// WEBPACK FOOTER //
// ./src/components/Orders/Modals/address.style.js